import { Box } from '@mui/material';
import React from 'react';
import { RangeSettingProps } from './type';
import RangePicker from '../RangePicker';
import RangeDisplay from '../RangeDisplay';

const RangeSetting: React.FC<RangeSettingProps> = ({ ranges, setRanges }) => {
  return (
    <Box>
      <RangePicker ranges={ranges} setRanges={setRanges} />
      <RangeDisplay ranges={ranges} setRanges={setRanges} />
    </Box>
  );
};

export default RangeSetting;
